
















































import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppFormCard from '@/components/AppFormCard.vue'
import AppTextInput from '@/components/AppTextInput.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import { UPDATE_USER } from '@/gql/user'
import { Common } from '@/mixins'

@Component({
  components: {
    AppFormCard,
    AppTextInput,
    AppTitleBar
  }
})
export default class extends Mixins(Common) {
  codeVerified = false
  phone = ''

  now = Math.floor(Date.now() / 1000)
  intervalId!: NodeJS.Timeout
  sentTime = 0
  code = ''

  mounted () {
    this.intervalId = setInterval(() => {
      console.log('ProfilePhone setInterval')
      this.now = Math.floor(Date.now() / 1000)
    }, 1000)
  }

  beforeDestroy () {
    clearInterval(this.intervalId)
  }

  async onClickRequestVerify () {
    const result = confirm('확인을 누르시면 입력하신 휴대폰 번호로 인증문자가 전송됩니다.')
    if (!result) return

    await this.$apollo.mutate({
      mutation: gql`mutation ($input: CreatePhoneIdentificationCodeInput!) {
        createPhoneIdentificationCode(input: $input) {
          success
        }
      }`,
      variables: { input: { phone: this.phone } }
    })

    await this.showToast('인증번호를 발송했습니다. 인증번호가 오지않은 경우 정보를 다시 확인해주세요.')
    this.sentTime = Math.floor(Date.now() / 1000)
  }

  get remainingTimeText () {
    const seconds = Math.max(0, 180 - (this.now - this.sentTime))
    return `0${Math.floor(seconds / 60)}:${(seconds % 60).toString().padStart(2, '0')}`
  }

  get codeButtonEnabled () {
    if (this.codeVerified || this.code.length !== 6) return false
    return /^\d+$/.test(this.code)
  }

  async onClickVerify () {
    const { data } = await this.$apollo.mutate({
      mutation: gql`mutation ($input: VerifyPhoneIdentificationCodeInput!) {
        verifyPhoneIdentificationCode(input: $input) {
          success
          message
        }
      }`,
      variables: { input: { phone: this.phone, code: this.code } }
    })

    if (data.verifyPhoneIdentificationCode.success) {
      await this.showToast('인증이 완료되었습니다.')
      this.codeVerified = true
    } else {
      await this.showToast(data.verifyPhoneIdentificationCode.message)
    }
  }

  async onClickSave () {
    const { data } = await this.$apollo.mutate({
      mutation: UPDATE_USER,
      variables: {
        input: {
          phone: this.phone.trim()
        }
      }
    })
    await this.showToast(data.updateUser.message)
    this.$router.back()
  }
}
